'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactI18next = require('react-i18next');

var _strings = require('helpers/strings');

var _responseCodes = require('helpers/responseCodes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./Auth.scss');

var Login = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loginData: state.auth.loginData,
    user: state.auth.user
  };
}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    (0, _classCallCheck3.default)(this, Login);
    return (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).apply(this, arguments));
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          loginData = _props.loginData;


      return _react2.default.createElement(
        'div',
        { className: 'homeContent ' + styles.auth },
        loginData.email && loginData._code === _responseCodes.playlistCodes.loginRequired ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h1',
            { className: styles.header },
            t('Welcome back {{username}}', { username: (0, _strings.concat)(' ', loginData.name, loginData.surname) }),
            '!'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.hint },
            t('Please enter your password below')
          )
        ) : _react2.default.createElement(
          'div',
          { className: styles.hint },
          t('Please login to verify your identity')
        ),
        _react2.default.createElement(_components.LoginForm, { className: styles.authForm, showTerms: !!loginData.email })
      );
    }
  }]);
  return Login;
}(_react.Component), _class2.propTypes = {
  loginData: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _temp)) || _class) || _class);
exports.default = Login;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/Login.js
// module id = 2143
// module chunks = 1